import React, { forwardRef, useImperativeHandle } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const SnackBarUI = forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const onClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: (message) => {
      setOpen(true);
      setMessage(message);
    },
  }));

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      onClose={onClose}
      message={message}
      action={
        <React.Fragment>
          <IconButton size='small' aria-label='close' color='inherit' onClick={onClose}>
            <CloseIcon fontSize='small' />
          </IconButton>
        </React.Fragment>
      }
    />
  );
});

export default SnackBarUI;
